<script lang="ts">
import { watchEffect } from 'vue';
import { preloadSfx } from '../lib/sfx';

export default {
  props: { name: String },
  setup(props) {
    watchEffect(() => preloadSfx(props.name));

    return () => null;
  }
};
</script>
